import React from 'react';

import { selectIsComplexOutcomeIslandOpen, selectOutcomeActions } from 'flow/store/redux/selectors';

import { useAppSelector } from '~/store/reduxHooks';

import SimpleOutcomeIsland from './SimpleOutcomeIsland';
import ComplexOutcomeIsland from './ComplexOutcomeIsland';
import { sortOutcomeActionsByPrecedenceIndex } from './helpers';


export default function OutcomeIsland() {
  const outcomeActions = useAppSelector(selectOutcomeActions);
  const isComplexIslandOpen = useAppSelector(selectIsComplexOutcomeIslandOpen);

  const Island = isComplexIslandOpen ? ComplexOutcomeIsland : SimpleOutcomeIsland;

  const sortedOutcomeActions = React.useMemo(
    () => sortOutcomeActionsByPrecedenceIndex(outcomeActions), [outcomeActions],
  );

  return (
    <Island data-pendo-anchor="evaluation-explainability-outcome-island" outcomeActions={sortedOutcomeActions} />
  );
}
